/* global $, prestashop */

$(document).ready(() => {
    console.log('front');
});
